module.exports = {"540234100":"宗嘎镇","540234101":"吉隆镇","540234200":"差那乡","540234201":"折巴乡","540234202":"贡当乡","540234203":"萨勒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540234.json
// module id = 2701
// module chunks = 0